import tw from 'twin.macro'

export const Optional = tw.div`text-light-500 text-[12px] font-ringside-narrow font-weight[300]`
export const Percentage = tw.span`text-[12px] font-ringside-narrow font-weight[300] text-white`
